module.exports = __webpack_public_path__ + "static/media/outline-format_align_right-24px.988d3227.svg";